const NotAuthorized = () => (
  <div style={{ padding: '2rem', textAlign: 'center', color: 'crimson' }}>
    <h2>🚫 Not Authorized</h2>
    <p>You do not have permission to view this page Please click on menu list.</p>
  </div>
);
export default NotAuthorized;
